import { HTMLAttributes } from 'react'

import Container from '@/components/base/container'
import Grid from '@/components/base/grid'
import MediaPlyr, { PlyrProps } from '@/components/base/media-plyr'
import Motion from '@/components/base/motion'
import Section from '@/components/base/section'

import { mediaBlockRevealAnimation } from './animations'
import { cn } from '@/lib/utils'

export type MediaBlockProps = HTMLAttributes<HTMLDivElement> &
  Partial<PlyrProps> &
  Partial<{
    is_fullscreen: boolean
    orientation: 'landscape' | 'portrait'
  }>

const MediaBlock = ({
  poster,
  image,
  video,
  youtube,
  use_video,
  video_type,
  is_autoplay,
  orientation,
  is_fullscreen,
  ...props
}: MediaBlockProps) => {
  return (
    <Motion animation={mediaBlockRevealAnimation}>
      {(motionRef) => (
        <Section ref={motionRef} {...props}>
          <Container>
            <Grid className="items-center gap-y-spacing-lg lg:grid-cols-8">
              <div
                className={cn(
                  'relative bg-surface-accent-light dark:bg-surface-accent-dark/10',
                  {
                    'col-span-2 aspect-video md:col-span-6 lg:col-span-12':
                      use_video && orientation === 'landscape',
                    'col-span-4 !mx-auto aspect-[9/16] md:col-span-4 md:col-start-2 lg:col-span-2 lg:col-start-4':
                      use_video && orientation === 'portrait',
                    'col-span-2 md:col-span-6 lg:col-span-8': !use_video
                  },
                  {
                    'mx-margin': !is_fullscreen,
                    'mx-0': is_fullscreen
                  }
                )}
                style={
                  !use_video && image
                    ? { aspectRatio: `${image.width} / ${image.height}` }
                    : undefined
                }
                data-motion-media
              >
                <MediaPlyr
                  image={image}
                  video={video}
                  poster={poster}
                  youtube={youtube}
                  use_video={use_video}
                  video_type={video_type}
                  is_autoplay={is_autoplay}
                />
              </div>
            </Grid>
          </Container>
        </Section>
      )}
    </Motion>
  )
}

export default MediaBlock
